<template>
  <cn-edit
    v-if="renderComp"
    @expDateSet="setExirationDate"
    @editSubmited="editConsent"
    @backEmit="cancel"
    modalSize="large"
    editModalLabel="Edit Consent"
    editModalTitle="Edit Consent"
  >
    <div class="row">
      <va-input
        :class="isExpiredClass"
        label="Consent Title"
        :disabled="true"
        v-model="consent.consentTitle"
      ></va-input>

      <va-input
        label="Form Title"
        :class="isExpiredClass"
        :disabled="true"
        v-model="selectedForm.formTitle"
      ></va-input>

      <va-date-picker
        :class="isExpiredClass"
        :disabled="true"
        label="Created Date"
        :config="{ dateFormat: 'd/m/Y' }"
        v-model="consent.createdDate"
      />

      <transition name="fade" mode="out-in">
        <va-date-picker
          v-if="showExpirationDate"
          :disabled="true"
          :class="isExpiredClass"
          label="Expiration Date"
          :config="{ dateFormat: 'd/m/Y' }"
          v-model="consent.expirationDate"
        />
      </transition>
    </div>

    <div class="flex">
      <va-input
        class="flex md12 xs12"
        label="Consent Question"
        type="textarea"
        :disabled="true"
        v-model="consent.consentQuestion"
      ></va-input>
    </div>

    <template v-slot:editSlot>
      <div class="flex row">
        <div>
          <va-input
            style="margin-inline-end:5%"
            label="Consent Title"
            :disabled="!canEdit"
            v-model="updatedConsent.consentTitle"
          ></va-input>
        </div>

        <div>
          <va-select
            style="background:inherit"
            label="Form Title"
            v-model="updatedForm"
            keyBy="_id"
            textBy="formTitle"
            :options="forms"
          ></va-select>
        </div>
      </div>
      <div class="flex">
        <va-input
          class="flex md12 xs12"
          label="Consent Question"
          type="textarea"
          :disabled="!canEdit"
          v-model="updatedConsent.consentQuestion"
        ></va-input>
      </div>
    </template>
  </cn-edit>
</template>

<script>
import cnEdit from "../../consentTemplates/Edit.vue";
import { editMixins } from "../../consentMixins/editMixins.js";
import consentService from "../consentsService.js"

export default {
  mixins: [editMixins],
  props: ["id"],
  data() {
    return {
      selectedForm: {
        _id: "",
        formTitle: ""
      },
      consent: {
        consentTitle: "",
        consentQuestion: "",
        formTitle: "",
        formId: "",
        createdDate: "",
        expirationDate: ""
      },
      updatedConsent: {
        consentTitle: "",
        consentQuestion: "",
        formTitle: "",
        formId: ""
      },
      updatedForm: {
        _id: "",
        formTitle: ""
      }
    };
  },
  computed: {
    canEdit() {
      return this.$store.getters.clearance;
    },
    renderComp() {
      return this.consent._id != undefined ? true : false;
    },
    forms() {
      return this.$store.getters.forms;
    },
    isExpiredClass() {
      return {
        flex: true,
        xs12: true,
        md4: this.consent.expirationDate == "",
        md3: this.consent.expirationDate != ""
      };
    },
    showExpirationDate() {
      return this.consent.expirationDate != "";
    }
  },
  methods: {
    setExirationDate(expirationDate) {
      if (this.consent.createdDate < expirationDate) {
        this.consent.expirationDate = expirationDate;
      }
    },
    editConsent() {
      if (this.updatedForm._id == undefined) {
        this.updatedConsent.formId = null;
      } else {
        this.updatedConsent.formId = this.updatedForm._id;
      }

      if (this.canEdit) {
        consentService
          .updateConsent(this.updatedConsent)
          .then(result => {
            const consent = result.data;
            this.$store.dispatch("setConsent", consent);

            this.$toasted.success("Consent Edited Succesfully", {
              icon: "fa-check",
              position: "top-right",
              duration: 2000,
              fullWidth: false
            });

            this.$router.go()
          })
          .catch(error => {
            const message =
              error.response.data.message == undefined
                ? "Something went wrong"
                : error.response.data.message;

            this.$toasted.error(message, {
              icon: "fa-close",
              position: "top-right",
              duration: 2000,
              fullWidth: false
            });
          });
      }
    },
    cancel() {
      this.$router.push({ name: "consents" });
    }
  },
  created() {
    Object.assign(this.consent, this.$store.getters.consent);

    if (this.consent.formTitle != "") {
      this.selectedForm.formTitle = this.consent.formTitle;
    } else {
      const forms = this.forms;
      for (var i in forms) {
        if (forms[i]._id == this.consent.formId) {
          this.selectedForm._id = forms[i]._id;
          this.selectedForm.formTitle = forms[i].formTitle;

          break;
        }
      }
    }

    if (this.canEdit) {
      Object.assign(this.updatedForm, this.selectedForm);
      Object.assign(this.updatedConsent, this.consent);
    } else {
      this.$delete(this.updatedConsent);
      this.$delete(this.updatedForm);
    }
  },
  components: {
    "cn-edit": cnEdit
  }
};
</script>

<style scoped>
va-input {
  display: flex;
}

.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 1s;
}
.fade-leave {
}
.fade-leave-active {
  transition: opacity 1s;
  opacity: 0;
}
</style>
